export class ValidationError extends Error {
}

export default class Validator {
    public static assertRequired(val: any): void {
        if (!val) {
            throw new ValidationError('To pole jest wymagane');
        }
    }

    public static assertNumber(val: string): void {
        if (!val?.match(/^(\d+)$/)) {
            throw new ValidationError('Podaj wartość liczbową');
        }
    }

    public static assertFloat(val: string): void {
        if (!val?.match(/^\d+(,\d+)?$/)) {
            throw new ValidationError('Podaj wartość liczbową');
        }
    }

    public static assertNames(val: string): void {
        if (!val?.match(/^[\p{L} \-]+$/iu)) {
            throw new ValidationError('Podaj prawidłową wartość');
        }
    }

    public static assertPpe(val: string): void {
        if (!val?.match(/^590\d{15}$/)) {
            throw new ValidationError('Numer Punktu Poboru Energii (PPE) składa się z 18 cyfr i znajdziesz go na swojej fakturze rozliczeniowej. Numer rozpoczyna się od cyfr: 590');
        }
    }

    public static assertZipCode(val: string): void {
        if (!val?.match(/^\d\d-\d\d\d$/)) {
            throw new ValidationError('Podaj prawidłowy kod pocztowy');
        }
    }

    public static assertEmail(val: string): void {
        if (!val?.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,}$/)) {
            throw new ValidationError('Podaj prawidłowy adres e-mail');
        }
    }

    public static isEmail(val: string): boolean {
        try {
            this.assertEmail(val);

            return true;
        } catch (e) {
            return false;
        }
    }

    public static assertPhone(val: string): void {
        if (!val?.match(/^\+?\d{9}$/)) {
            throw new ValidationError('Podaj prawidłowy numer telefonu');
        }
    }

    public static isPhone(val: string): boolean {
        try {
            this.assertPhone(val);

            return true;
        } catch (e) {
            return false;
        }
    }

    public static assertPesel(val: string): void {
        if (!val?.match(/^\d{11}$/)) {
            throw new ValidationError('Podaj prawidłowy numer PESEL');
        }

        const list = val.split('').map(v => parseInt(v));

        const weights = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3];

        let sum = 0;

        for (let i = 0; i < 10; i++) {
            const v = list[i];
            const w = weights[i];

            sum += v * w;
        }

        let r = sum % 10;

        if (r) {
            r = 10 - r;
        }

        if (r != list[10]) {
            throw new ValidationError('Podaj prawidłowy numer PESEL');
        }
    }
}
